import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.abarbeiter-mit-rollen-zentrale-admin';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsAbarbeiterMitRollenZentraleAdminEffects {

    AbarbeiterMitRollenZentraleAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN),
        mergeMap((x: ac.GetAbarbeiterMitRollenZentraleAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAbarbeiterMitRollenZentraleAdmin().pipe(
                map((result: any) => {
                    return new ac.GetAbarbeiterMitRollenZentraleAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAbarbeiterMitRollenZentraleAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentVorlageQueryService);
        }
        return this.service;
    }
}
